'kiwi public';

import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _ from 'lodash';
import * as IrcdDiffs from '@/helpers/IrcdDiffs';
import * as Misc from '@/helpers/Misc';
import AutoComplete from './AutoComplete';
var getInviteListSorter = function getInviteListSorter(extban) {
  if (!extban) {
    return function (a, b) {
      return Misc.strCompare(a.invited, b.invited);
    };
  }
  var extbanColon = extban + ':';
  return function (a, b) {
    var aAccount = a.invited.indexOf(extbanColon) === 0;
    var bAccount = b.invited.indexOf(extbanColon) === 0;
    if (aAccount && !bAccount) {
      return -1;
    } else if (!aAccount && bAccount) {
      return 1;
    }
    return Misc.strCompare(a.invited, b.invited);
  };
};
export default {
  components: {
    AutoComplete: AutoComplete
  },
  props: ['buffer'],
  data: function data() {
    return {
      inviteMaskOrAccount: '',
      inviteList: [],
      is_refreshing: false,
      clickUpdateTimeout: 0
    };
  },
  computed: {
    supportsAccounts: function supportsAccounts() {
      return !!this.extban;
    },
    extban: function extban() {
      return IrcdDiffs.extbanAccount(this.buffer.getNetwork());
    },
    channelIsInviteOnly: function channelIsInviteOnly() {
      return typeof this.buffer.modes.i !== 'undefined';
    },
    areWeAnOp: function areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    sortedInviteList: function sortedInviteList() {
      var _context, _context2;
      var sorter = getInviteListSorter(this.extban);
      return _sortInstanceProperty(_context = _sliceInstanceProperty(_context2 = this.inviteList).call(_context2)).call(_context, sorter);
    },
    inviteListAccounts: function inviteListAccounts() {
      var _context3;
      var extbanColon = this.extban + ':';
      return this.supportsAccounts ? _filterInstanceProperty(_context3 = this.inviteList).call(_context3, function (i) {
        return i.invited.indexOf(extbanColon) === 0;
      }) : [];
    },
    anyRegisteredUserCanJoin: function anyRegisteredUserCanJoin() {
      if (!this.supportsAccounts) {
        return false;
      }
      if (!this.channelIsInviteOnly) {
        return false;
      }
      var extbanColon = this.extban + ':';

      // Find any invite that only consists of the extban and nothing else. Eg. '~a:'
      return this.inviteListAccounts.some(function (i) {
        return i.invited === extbanColon;
      });
    },
    knownAccounts: function knownAccounts() {
      var _context4, _context5;
      // Get an array of every account name we're aware of on the network, excluding
      // the ones we already have in our invite list
      var extbanColon = this.extban + ':';
      var accountMapper = function accountMapper(invite) {
        return invite.invited.replace(extbanColon, '');
      };
      var existingInviteAccounts = _mapInstanceProperty(_context4 = this.inviteListAccounts).call(_context4, accountMapper);
      var users = this.buffer.getNetwork().users;
      var accountUsers = [];
      _Object$values(users).forEach(function (user) {
        if (user.account && !_includesInstanceProperty(existingInviteAccounts).call(existingInviteAccounts, user.account)) {
          accountUsers.push(user);
        }
      });
      var autocompleteMapper = function autocompleteMapper(user) {
        var text = user.account;
        if (user.account !== user.nick) {
          text += " (".concat(user.nick, ")");
        }
        return {
          text: text,
          user: user
        };
      };
      return _mapInstanceProperty(_context5 = _.orderBy(accountUsers, ['account', 'nick'])).call(_context5, autocompleteMapper);
    }
  },
  watch: {
    buffer: function buffer() {
      this.inviteList = [];
      this.is_refreshing = false;
      this.clickUpdateTimeout = 0;
      this.updateInvitelist();
    }
  },
  created: function created() {
    var _this = this;
    this.listen(this.$state, 'irc.mode', function (event, network) {
      if (network !== _this.buffer.getNetwork()) {
        return;
      }
      if (!network.ircClient.caseCompare(event.target, _this.buffer.name)) {
        return;
      }
      event.modes.forEach(function (change) {
        if (change.mode.length !== 2 || change.mode[1] !== 'I') {
          return;
        }
        if (change.mode[0] === '+') {
          _this.inviteList.push({
            invited: change.param,
            invited_at: Math.floor(event.time / 1000),
            invited_by: event.nick,
            channel: event.target
          });
        } else if (change.mode[0] === '-') {
          var _context6;
          _this.inviteList = _filterInstanceProperty(_context6 = _this.inviteList).call(_context6, function (invite) {
            return invite.invited !== change.param;
          });
        }
      });
    });
    this.updateInvitelist();
  },
  methods: {
    displayMask: function displayMask(inviteMask) {
      return inviteMask.replace(this.extban + ':', '') || this.$t('invite_any_registered');
    },
    clickUpdateInvitelist: function clickUpdateInvitelist() {
      var _this2 = this;
      if (this.clickUpdateTimeout) {
        return;
      }
      this.clickUpdateTimeout = setTimeout(function () {
        _this2.clickUpdateTimeout = 0;
      }, 4000);
      this.updateInvitelist();
    },
    updateInvitelist: function updateInvitelist() {
      var _this3 = this;
      if (this.is_refreshing || this.buffer.getNetwork().state !== 'connected') {
        return;
      }
      var channelName = this.buffer.name;
      var network = this.buffer.getNetwork();
      this.is_refreshing = true;
      this.buffer.getNetwork().ircClient.inviteList(channelName, function (event) {
        var currentNetwork = _this3.buffer.getNetwork();
        var bufferMatches = currentNetwork.ircClient.caseCompare(_this3.buffer.name, event.channel);
        if (!bufferMatches || network !== currentNetwork) {
          // The buffer or network changed since making the request
          return;
        }
        _this3.inviteList = event ? event.invites : [];
        _this3.is_refreshing = false;
      });
    },
    addInvite: function addInvite() {
      var _context7;
      var maskOrAccount = _trimInstanceProperty(_context7 = this.inviteMaskOrAccount).call(_context7);
      if (!maskOrAccount) {
        return;
      }
      var ircClient = this.buffer.getNetwork().ircClient;
      var isMask = _includesInstanceProperty(maskOrAccount).call(maskOrAccount, '@') || _includesInstanceProperty(maskOrAccount).call(maskOrAccount, ':');
      if (this.supportsAccounts && !isMask) {
        var _context8;
        ircClient.addInvite(this.buffer.name, _concatInstanceProperty(_context8 = "".concat(this.extban, ":")).call(_context8, maskOrAccount));
      } else {
        ircClient.addInvite(this.buffer.name, maskOrAccount);
      }
      this.inviteMaskOrAccount = '';
    },
    removeInvite: function removeInvite(mask) {
      var channelName = this.buffer.name;
      this.buffer.getNetwork().ircClient.removeInvite(channelName, mask);
    },
    setInviteOnly: function setInviteOnly() {
      this.buffer.getNetwork().ircClient.mode(this.buffer.name, '+i');
    },
    removeInviteOnly: function removeInviteOnly() {
      this.buffer.getNetwork().ircClient.mode(this.buffer.name, '-i');
    },
    accountSelected: function accountSelected(_value, item) {
      this.inviteMaskOrAccount = item.user.account;
    },
    inviteKeyDown: function inviteKeyDown(event) {
      if (!this.$refs.autocomplete) {
        return;
      }
      var autoComplete = this.$refs.autocomplete;
      if (event.key === 'Tab') {
        event.preventDefault();
        autoComplete.selectCurrentItem();
        return;
      }
      var selectedItem = autoComplete.selectedItem;
      if (event.key === 'Enter' && selectedItem.user.account === this.inviteMaskOrAccount) {
        event.preventDefault();
        this.addInvite();
        return;
      }
      this.$refs.autocomplete.handleOnKeyDown(event);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelInvitelist"]
window._kiwi_exports.components.ChannelInvitelist = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
